import React from 'react'
import { useIntl } from 'react-intl'

import Divider from './Common/Divider'
import NotesRender from './Common/NotesRender'
import StartAndEndDateTime from './Common/StartAndEndDateTime'
import DefaultSummaryModalFooter from './Common/SummaryModalFooter/DefaultSummaryModalFooter'

import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import useModalCallbacks from 'tripPlanner/hooks/View/useModalCallbacks'
import type { NoteItem } from 'tripPlanner/types/tripItem'

interface Props {
  item: NoteItem
}

function NoteItemSummary(props: Props) {
  const { item } = props
  const intl = useIntl()

  const { closeModal, goBack } = useModalCallbacks()
  const { title, startDate, endDate, notes } = item

  const hasAdditionalInfo = startDate || endDate

  const noteFallbackTitle = intl.formatMessage({
    id: 'lzefslw0+5',
    defaultMessage: 'Note',
    description: 'Fallback title for a note trip item when no title is provided',
  })
  const startDateLabel = intl.formatMessage({
    id: 'ZG9ZpaLkHH',
    defaultMessage: 'Start date',
    description: 'Label for the start date field in a note trip item summary',
  })
  const dateLabel = intl.formatMessage({
    id: 'zivJNDIMaU',
    defaultMessage: 'Date',
    description: 'Label for the date field in a note trip item summary when there is no end date',
  })
  const endDateLabel = intl.formatMessage({
    id: 'e+A9K32QX8',
    defaultMessage: 'End date',
    description: 'Label for the end date field in a note trip item summary',
  })

  return (
    <>
      <ModalHeader
        title={title?.trim() || noteFallbackTitle}
        onCloseButtonClick={closeModal}
        onBackButtonClick={goBack}
      />

      <ModalBody>
        <ModalContent>
          <VerticalSpacer gap={20}>
            {notes && (
              <NotesRender type="compact" fontSize="large" content={notes} />
            )}
            {hasAdditionalInfo && <Divider />}
            <StartAndEndDateTime
              startTitle={endDate ? startDateLabel : dateLabel}
              endTitle={endDateLabel}
              item={item}
            />
          </VerticalSpacer>
        </ModalContent>
      </ModalBody>

      <DefaultSummaryModalFooter item={item} />
    </>
  )
}

export default NoteItemSummary
